export default __webpack_public_path__ + "static/media/misc-bathtubA-1440w.7d88ef1d.webp";